import loadable from '@loadable/component';

// 懒加载组件
const DeliveryManagement = loadable(() => import('./deliveryManagement/DeliveryManagement'));
const DeliveryModify = loadable(() => import('./deliveryManagement/deliveryModify/DeliveryModify'));
const DeliveryReturnQuery = loadable(() => import('./deliveryReturnQuery/DeliveryReturnQuery'));

export const subRoutes = [
  {
    // 424002 药品发货单管理
    path: '/DeliveryManagement',
    component: DeliveryManagement
  },
  {
    // 424002: 药品发货单管理 --- 发货单修改
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    // 424003 药品退货单确认
    path: '/DeliveryReturnQuery',
    component: DeliveryReturnQuery
  }
];
